import { useEffect, useRef } from "react";

// Hook that reveals children when they enter the viewport.
export function useReveal() {
    const ref = useRef(null);
    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((e) => {
                    if (e.isIntersecting) {
                        e.target.classList.add("is-visible");
                        io.unobserve(e.target);
                    }
                });
            },
            { threshold: 0.12, rootMargin: "0px 0px -60px 0px" }
        );
        el.querySelectorAll(".reveal").forEach((n) => io.observe(n));
        return () => io.disconnect();
    }, []);
    return ref;
}
